import script from "./SystemMasters.vue?vue&type=script&setup=true&lang=js"
export * from "./SystemMasters.vue?vue&type=script&setup=true&lang=js"

import "./SystemMasters.vue?vue&type=style&index=0&id=3228a4b2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3228a4b2"]])

export default __exports__